import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import {
  createLazyFetchingItemsSlice,
  type LazyFetchingItemsState,
} from "../../../../Application/slices/createLazyFetchingItemsSlice";
import { type PeopleAvailableFlow } from "../../models";

export type ContentToPeopleAssignmentsState = LazyFetchingItemsState<PeopleAvailableFlow>;

export const initialState: ContentToPeopleAssignmentsState = {
  areAllLoaded: false,
  isLoading: false,
  items: [],
  itemsCount: 0,
};

const slice = createLazyFetchingItemsSlice<PeopleAvailableFlow, ContentToPeopleAssignmentsState>({
  namePayload: {
    namespace: ReducerNamespaceTypes.People,
    entity: ReducerEntityPrefixTypes.AddContent,
    name: "contentToPeopleAssignments",
  },
  initialState,
  reducers: {},
});

export const { fetchBegin, fetchSuccess, fetchFailure, reset } = slice.actions;

export default slice.reducer;

export type ContentAssignmentState = ReturnType<typeof slice.reducer>;
